export class BaseAppEvent {}
